module.exports = __webpack_public_path__ + "static/media/DATA.c15d6b4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/DATA.svg
// module id = 389
// module chunks = 25